import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Box from "@material-ui/core/Box";
import { NavLink } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "sticky",
    top: 0,
    zIndex: 2,
    animation: "float 6s ease-in-out infinite",
    WebkitBoxShadow: "none !important",
    MozBoxShadow: "none !important",
    boxShadow: "none !important",
    textTransform: "uppercase",
    fontWeight: "bold",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  strikeThrough: {
    textDecoration: "line-through",
    color: "white",
  },
  title: {
    color: "white",
  },
}));

export default function MenuAppBar() {
  const classes = useStyles();
  const checkActive = (match, location) => {
    if (!location) return false;
    const { pathname } = location;
    return pathname === "/";
  };
  return (
    <div className={classes.root}>
      <AppBar
        position="fixed"
        style={{
          backgroundColor: "transparent",
        }}
        elevation="0"
      >
        <Toolbar style={{ display: "flex", justifyContent: "center" }}>
          <NavLink
            to="/"
            activeClassName={classes.strikeThrough}
            isActive={checkActive}
            className={classes.title}
          >
            Trang chủ
          </NavLink>
          <Box width="10%"></Box>
          <NavLink
            to="/menu"
            activeClassName={classes.strikeThrough}
            className={classes.title}
          >
            Thực đơn
          </NavLink>
          <Box width="10%"></Box>
          <NavLink
            to="/about"
            activeClassName={classes.strikeThrough}
            className={classes.title}
          >
            Về chúng tôi
          </NavLink>
          <Box width="10%"></Box>
          <NavLink
            to="/contact"
            activeClassName={classes.strikeThrough}
            className={classes.title}
          >
            Liên hệ
          </NavLink>
        </Toolbar>
      </AppBar>
    </div>
  );
}
